import { useState, useCallback } from 'react';

const useWindowScrollToggle = () => {
  const [isFrozen, setIsFrozen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const toggleWindowScroll = useCallback(
    (state: boolean) => {
      const body = document.querySelector('body');

      if (!body) return;
      if (state && isFrozen) return;

      if (state) {
        const currentScrollY = window.pageYOffset;
        setScrollPosition(currentScrollY);
        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${currentScrollY}px`;
        body.style.width = '100%';
      } else {
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
      }

      setIsFrozen(state);
    },
    [isFrozen, scrollPosition]
  );

  return { toggleWindowScroll, isFrozen };
};

export default useWindowScrollToggle;
